import { Box, Typography, Card, CardContent } from "@mui/material";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import MedicationIcon from "@mui/icons-material/Medication";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import ScienceIcon from "@mui/icons-material/Science";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import MedicationLiquidIcon from "@mui/icons-material/MedicationLiquid";
import ApartmentIcon from "@mui/icons-material/Apartment";
import SchoolIcon from "@mui/icons-material/School";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { useEffect, useRef, useState } from "react";
import { Description } from "@mui/icons-material";

const hospitals = [
  "K.E.M. Hospital",
  "Sassoon General Hospital",
  "Poona Hospital & Research Centre",
  "Joshi Hospital",
  "Ratna Memorial Hospital",
  "Ekbote Hospital",
  "Kamla Nehru Hospital",
  "Pune University Health Centre",
  "Jehangir Hospital",
  "Wadia Hospital",
  "PES Modern College of Physiotherapy OPD",
  "Police hospital & maternity home, Shivajinagar",
  "Divyang Kalyankari Shikshan Sanstha",
  "Sahajeevan- oldage home",
  "Primary Health Care (PHC) - Loni & Kunjirwadi",
];

const icons = [
  <MedicalServicesIcon
    sx={{ fontSize: { xs: 24, md: 27 }, color: "#f2ca30" }}
  />,
  <MedicationIcon sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }} />,
  <ScienceIcon sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }} />,
  <LocalHospitalIcon sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }} />,
  <VaccinesIcon sx={{ fontSize: { xs: 27, md: 28 }, color: "#f2ca30" }} />,
  <LocalHospitalIcon sx={{ fontSize: { xs: 24, md: 28 }, color: "#f2ca30" }} />,
  <MedicalServicesIcon
    sx={{ fontSize: { xs: 24, md: 27 }, color: "#f2ca30" }}
  />,
  <SchoolIcon sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }} />,
  <MedicationLiquidIcon
    sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }}
  />,
  <CorporateFareIcon sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }} />,
  <ApartmentIcon sx={{ fontSize: { xs: 24, md: 28 }, color: "#f2ca30" }} />,
  <LocalPoliceIcon sx={{ fontSize: { xs: 24, md: 28 }, color: "#f2ca30" }} />,
  <HealthAndSafetyIcon
    sx={{ fontSize: { xs: 24, md: 28 }, color: "#f2ca30" }}
  />,
  <HomeWorkIcon sx={{ fontSize: { xs: 24, md: 28 }, color: "#f2ca30" }} />,
  <LocalPharmacyIcon sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }} />,
  <EventAvailableIcon
    sx={{ fontSize: { xs: 26, md: 28 }, color: "#f2ca30" }}
  />,
];

const events = [
    {
    date: "April 26", description: "MET workshop"
  },
   {
    date: "April 26", description: "Renaissance"
  },
    {
    date: "April 26", description: "World Parkinson’s day"
  },
   {
    date: "April 26", description: "World autism day"
  },
    {
    date: "April 26", description: "LOR writing and Career counselling session"
  },
    {
    date: "March 26", description: "Convocation ceremony"
  },
   {
    date: "March 26", description: "Aerobic exercise & training"
  },
    {
    date: "March 26", description: "World down syndrome day: Guest lecture/ camp"
  },
  {
    date: "March 26", description: "Research methodology workshop"
  },
   {
    date: "March 26", description: "Guest lecture: orientation international language examination"
  },
   {
    date: "March 26", description: "International Women’s Day Celebration"
  },
   {
    date: "March 26", description: "Workshop on Spine Manipulations"
  },  
    {
    date: "March 26", description: "World obesity day"
  }, 
    {
    date: "February 26", description: "Orientation of whirlpool and contrast bath"
  },
  {
    date: "February 26", description: "Recruitment drive"
  },
     {
    date: "February 26", description: "Awareness camp at PHC"
  },
   {
    date: "January 26", description: "Republic day celebration"
  },
  {
    date: "Augest", description: "Worls Breast Feeding Week: Awareness lecture- Various breast-feeding positions"
  },
  {
    date: "Augest", description: "IASTM Workshop: Musculoskeletal department"
  },
  {
    date: "Augest", description: "Orientation of Laser Therapy"
  },
  {
    date: "Augest", description: "Letter Of Recommendation (LOR) Writing Session"
  },
  {
    date: "Augest", description: "Poster making competition: Gender Sensitization committee"
  },
  {
    date: "Augest", description: "How to crack an interview- Physiotherapist’s perspective: "
  },
  {
    date: "September", description: "SCI day celebration"
  },
  {
    date: "September", description: "Teachers’ day celebration"
  },
  {
    date: "September", description: "World PT Day: Knee club inauguration & slogan competition"
  },
  {
    date: "September", description: "Awareness lecture on diabetes"
  },
  {
    date: "September", description: "Personality development workshop"
  },
  {
    date: "September", description: "Bolly-hop dance workshop"
  },
  {
    date: "September", description: "Life saving skills: hands on session"
  },
  {
    date: "September", description: "World heart Day celebration"
  },
  {
    date: "September", description: "Workshop: exercise physiology by Dr Atharva Dolle"
  }
  // { date: "02.09.2024", description: "World Physiotherapy Day: Rally" },
  // { date: "03.09.2024", description: "Industrial Visit" },
  // {
  //   date: "04.09.2024",
  //   description:
  //     "Low back pain assessment, ergonomics and treatment camp for Modern Institutes",
  // },
  // {
  //   date: "05.09.2024",
  //   description: "World Physiotherapy Day: Poster Making Competition",
  // },
  // {
  //   date: "06.09.2024",
  //   description: "World Physiotherapy Day: Reel Making competition",
  // },
  // {
  //   date: "06.09.2024",
  //   description: "World Physiotherapy Day: Blog writing competition",
  // },
  // {
  //   date: "13.09.2024",
  //   description:
  //     "Free physiotherapy camp in association with Shrimant Bhausaheb Rangari trust",
  // },
  // {
  //   date: "20.09.2024",
  //   description: "CME: The Knee, from Mechanics to Functional Assessment",
  // },
  // {
  //   date: "23.09.2024",
  //   description: "American Heart Association’s Basic Life Support Workshop",
  // },
  // { date: "23.09.2024", description: "LASER Demo and Application" },
];

const MultiCarousel = () => {
  const hospitalContainerRef = useRef(null);
  const eventContainerRef = useRef(null);
  const [hospitalAnimationDuration, setHospitalAnimationDuration] = useState(0);
  const [eventAnimationDuration, setEventAnimationDuration] = useState(0);

  const SCROLL_SPEED = 20;
  const ROLL_MAX_HEIGHT = 360;

  useEffect(() => {
    const updateAnimationDuration = (
      ref: any,
      setDuration: any,
      itemCount: any
    ) => {
      if (ref.current) {
        const containerHeight = ref.current.offsetHeight;
        const duration = containerHeight / SCROLL_SPEED;
        setDuration(duration > 0 ? duration : 10);
      }
    };

    updateAnimationDuration(
      hospitalContainerRef,
      setHospitalAnimationDuration,
      hospitals.length
    );
    updateAnimationDuration(
      eventContainerRef,
      setEventAnimationDuration,
      events.length
    );

    window.addEventListener("resize", () => {
      updateAnimationDuration(
        hospitalContainerRef,
        setHospitalAnimationDuration,
        hospitals.length
      );
      updateAnimationDuration(
        eventContainerRef,
        setEventAnimationDuration,
        events.length
      );
    });

    return () => {
      window.removeEventListener("resize", () => {
        updateAnimationDuration(
          hospitalContainerRef,
          setHospitalAnimationDuration,
          hospitals.length
        );
        updateAnimationDuration(
          eventContainerRef,
          setEventAnimationDuration,
          events.length
        );
      });
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "secondary.light",
        p: { xs: 2, md: 4 },
        width: "96%",
        marginTop: 1,
        gap: { md: 5, xs: 3, sm: 3 },
      }}
    >
      {/* Hospital Attachments */}
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <Typography
          variant="h4"
          textAlign="start"
          color="primary.main"
          my={2}
          marginTop={0}
          marginLeft={1}
          sx={{ fontSize: { xs: "h5.fontSize", md: "h4.fontSize" } }}
        >
          {" "}
          Hospital Attachments{" "}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            overflowY: "scroll",
            maxHeight: `${ROLL_MAX_HEIGHT}px`,
            position: "relative",
          }}
        >
          <Box
            ref={hospitalContainerRef}
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
              gap: 2,
              animation: `scrollHospitals-animation ${hospitalAnimationDuration}s linear infinite`,
              "@keyframes scrollHospitals-animation": {
                "0%": { transform: "translateY(0)" },
                "100%": { transform: "translateY(-100%)" },
              },
              "&:hover": {
                animationPlayState: "paused",
              },
            }}
          >
            {[...hospitals].map((name, index) => (
              <Card
                key={index}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  p: { xs: 0.5, md: 0 },
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  height: "auto",
                  minHeight: { xs: "100px", md: "100px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#dae3f5",
                    color: "#ffffff",
                  },
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    width: "100%",
                    padding: { xs: 1, md: 2 },
                    flexDirection: "row",
                    justifyContent: "flex-start",
                  }}
                >
                  {icons[index % icons.length]}
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: 13, md: 15 },
                      fontWeight: 300,
                      color: "secondary.main",
                      mt: { xs: 1, md: 1 },
                    }}
                  >
                    {name}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Events */}
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <Typography
          variant="h4"
          textAlign="start"
          color="primary.main"
          my={2}
          marginTop={0}
          marginLeft={1}
          sx={{
            fontSize: {
              xs: "h5.fontSize",
              sm: "h5.fontSize",
              md: "h4.fontSize",
            },
          }}
        >
          UPCOMING EVENTS
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            overflowY: "scroll",
            maxHeight: `${ROLL_MAX_HEIGHT}px`,
            position: "relative",
          }}
        >
          <Box
            ref={eventContainerRef}
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
              gap: 2,
              animation: `scrollEvents-animation ${eventAnimationDuration}s linear infinite`,
              "@keyframes scrollEvents-animation": {
                "0%": { transform: "translateY(0)" },
                "100%": { transform: "translateY(-100%)" },
              },
              "&:hover": {
                animationPlayState: "paused",
              },
            }}
          >
            {[...events].map((event, index) => (
              <Card
                key={index}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  p: { xs: 0.5, md: 0 },
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  height: "auto",
                  minHeight: { xs: "120px", sm: "120px", md: "100px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#dae3f5",
                    color: "#ffffff",
                  },
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    width: "100%",
                    padding: { xs: 1, md: 1.5 },
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: 14, sm: 14, md: 15 },
                      fontWeight: "bold",
                      color: "#f2ca30",
                      mt: { xs: 1, sm: 1, md: 1 },
                      mb: { xs: 0, sm: 0, md: 0 },
                    }}
                  >
                    {event.date}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: { xs: 14, sm: 14, md: 15 },
                      fontWeight: 300,
                      color: "secondary.main",
                      mt: { xs: 0.5, md: 0 },
                    }}
                  >
                    {event.description}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MultiCarousel;
